<script setup>
import BaseIcon from "@/library/BaseIcon.vue";
import BaseText from "@/library/BaseText.vue";

import ForYouDiscoverListItem from "@/features/ForYou/ForYouDiscoverListItem.vue";

defineProps({
  discoverFeatures: {
    type: Array,
    required: true,
  },
});
</script>

<template>
  <div class="for-you-discover-list">
    <div class="for-you-discover-list__header">
      <BaseIcon
        name="search"
        class="for-you-discover-list__header-icon"
      />
      <BaseText
        as="h1"
        variant="headline-3-medium"
        class="for-you-discover-list__header-title"
      >
        Discover new kinds of protection
      </BaseText>
      <BaseText
        as="h2"
        variant="headline-6-medium"
        class="for-you-discover-list__header-subtitle"
      >
        Included with your subscription
      </BaseText>
    </div>

    <div class="for-you-discover-list__features">
      <ForYouDiscoverListItem
        v-for="feature in discoverFeatures"
        :key="feature.id"
        :feature="feature"
        class="for-you-discover-list__features-item"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* stylelint-disable */
.for-you-discover-list {
  &__header {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;

    &-icon {
      display: block;
      width: 32px;
      height: 32px;
      font-size: 32px;
      font-weight: 500;
    }

    &-subtitle {
      color: $color-primary-70;
    }
  }

  &__features {
    margin-top: 25px;
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;

    @media (min-width: 1090px) {
      grid-template-columns: repeat(auto-fit, minmax(355px, 2fr));
    }

    &-item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      flex-wrap: wrap;
      max-width: 100%;

      @media (min-width: 1090px) {
        &:only-child {
          width: 50%;
          margin-left: 0;
        }
      }
    }
  }
}
</style>
